export enum RequestStatusId {
    Submitted=1,
    Withdrawn=2,
    Approved=3,
    Denied=4,
    Draft=5,
    UpdateRequest=6,
    DisclosureAnalysis=7
}

export enum RequestActionId{
    Edit=100,
    Delete=101,
    Duplicate=102,
    Submit=103,
    Resubmit=106,
    OpenSummary=104,
    OpenManageTeam=110,
    View=105,
    AssignToMePrimary=107,
    AssignToMeSupport=108,
    UnassignFromMe=109,
    ReactivateRequest=111
}

export enum RequestReasonId{
    DeniedNoSensitiveInfo=1,
    DeniedNotConfidential=2,
    DeniedInsufficientInfo=3,
    DeniedInvalidContent=4,
    DeniedOther=5,
    WithdrawnOther=6
}
export enum Language{
    English="en",
    French="fr"
}
export enum UserRole{
    Researcher=1,
    Analyst=2,
    Admin=3
}

export enum CustomEvents{
    PageLoaded="pageLoaded"
}

export enum SnackbarSeverity{
    Success="success",
    Error="error",
    Warning="warning"
}

export const MAX_OUTPUT_FILES=5//TODO: determine value to use
export const MAX_OUTPUT_SUPPORT_FILES=15//TODO: determine value to use
export const MAX_SUPPORT_FILES=15//TODO: determine value to use